export default __webpack_public_path__ + "static/media/x-full.03403257.svg";